// src/api/misc.ts

import { BASE_URL } from "../utils/config";
import { ContactFormData, Jackpot } from "../types/api";
import { messageToast } from "../components/common/toastMessage"; // Direct UI call - consider refactoring

/**
 * Fetches details for a specific jackpot by its ID.
 * @param jackpotId - The ID of the jackpot.
 * @returns A promise resolving to the Jackpot object.
 * @throws {Error} If the request fails.
 */
export async function fetchJackpotDetails(
	jackpotId: number | string
): Promise<Jackpot> {
	const url = `${BASE_URL}/jackpot/${jackpotId}`;
	try {
		const response = await fetch(url, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});

		if (!response.ok) {
			throw new Error(`Failed to fetch jackpot details: ${response.status}`);
		}
		return (await response.json()) as Jackpot;
	} catch (error: any) {
		console.error(`Error fetching jackpot details for ID ${jackpotId}:`, error);
		messageToast({
			message: "An error occurred while retrieving the jackpot data",
			background: "text-bg-danger",
		}); // Direct UI call
		throw new Error(
			error.message || "An error occurred while fetching jackpot details."
		);
	}
}
